<template>
  <div class="page-wrapper">
    <breadcrumb :items="breadcrumbItems" />
    <carregamento v-if="carregando" />
    <main class="main-content" v-else>
      <div class="content-card">
        <!-- Breadcrumb -->

        <!-- Título -->
        <h1 class="page-title">{{ vaga.titulo }}</h1>

        <!-- Período, Local, Tipo e Status -->
        <div class="info-row">
          <div class="info-item">
            <span class="info-label">Período de Inscrição:</span>
            <span class="info-date">{{
              formatarData(vaga.dataInicioInscricao)
            }}</span>
            <span class="info-date highlight">{{
              formatarData(vaga.dataFimInscricao)
            }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Local da vaga:</span>
            <span class="info-value">{{ vaga.localVaga }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Tipo da vaga:</span>
            <span class="tipo-vaga-badge" :class="tipoVagaClasse">
              {{ tipoVagaTexto }}
            </span>
          </div>
          <div class="info-item">
            <span class="info-label">Status:</span>
            <span class="status-badge" :class="statusEfetivo.toLowerCase()">
              <template v-if="statusEfetivo === 'ABERTA'">Inscrições Abertas</template>
              <template v-else-if="statusEfetivo === 'BREVE'">Inscrições em Breve</template>
              <template v-else-if="statusEfetivo === 'ENCERRADA'">Inscrições Encerradas</template>
              <template v-else-if="statusEfetivo === 'CANCELADA'">Vaga Cancelada</template>
              <template v-else>{{ statusEfetivo }}</template>
            </span>
          </div>
        </div>

        <div class="info-row" v-if="nomeAcaoExtensao">
          <div class="info-item">
            <span class="info-label">Ação de extensão:</span>
            <router-link
              v-if="acaoExtensaoId"
              :to="{ name: 'acao-informacoes', params: { id: acaoExtensaoId } }"
              class="info-link"
            >
              {{ nomeAcaoExtensao }}
            </router-link>
            <span v-else class="info-value">{{ nomeAcaoExtensao }}</span>
          </div>
        </div>

        <!-- Painel de Métricas de Engajamento (Visível para Autor, Coordenador e Admin) -->
        <div class="metrics-panel" v-if="podeEditarOuExcluir">
          <div class="metric-card">
            <div class="metric-info">
              <span class="metric-value">{{ vaga.visualizacoes || 0 }}</span>
              <span class="metric-label">Visualizações</span>
            </div>
          </div>
          <div class="metric-card"
            title="Mede a quantidade de acessos ao link de inscrição. Não garante o preenchimento do formulário externo.">
            <div class="metric-info">
              <span class="metric-value">{{ vaga.cliquesInscricao || 0 }}</span>
              <span class="metric-label">Acessos à Inscrição</span>
            </div>
          </div>
        </div>

        <!-- Divisor roxo -->
        <hr class="divider" />

        <!-- Tags -->
        <div class="tags-row">
          <span class="tag" v-for="tag in vaga.tags" :key="tag">{{ tag }}</span>
        </div>

        <!-- Imagem da vaga centralizada no topo -->
        <div class="vaga-imagem-topo" v-if="temImagemVaga">
          <img
            :src="vaga.imagemUrl"
            :alt="vaga.descricaoImagem || 'Imagem da Vaga'"
            class="vaga-image"
          />
        </div>

        <!-- Texto da vaga -->
        <div class="vaga-text" v-html="vaga.textoInformativo"></div>

        <!-- Seção da ação com logotipo -->
        <hr class="divider" />
        <div class="nerds-section">
          <div class="nerds-image-wrapper">
            <img
              :src="logoAcao || vaga.acaoImagemUrl"
              :alt="vaga.acaoTitulo || 'Logo da Ação'"
              class="nerds-image"
            />
          </div>
          <div class="nerds-text">
            <h2 class="nerds-title">{{ vaga.acaoTitulo }}</h2>
            <p>
              {{ vaga.textoDescricaoAcao }}
            </p>
          </div>
        </div>

        <!-- Botões de ação -->
        <div class="action-buttons">
          <button class="btn btn-outline" v-if="podeEditarOuExcluir" @click="irParaEdicao">
            Editar Vaga
          </button>
          <button class="btn btn-danger" v-if="podeEditarOuExcluir" @click="confirmarExclusao">
            Excluir Vaga
          </button>
          <a class="btn btn-outline" v-if="vaga.linkEdital" :href="vaga.linkEdital" target="_blank"
            @click="handleCliqueInscricao">Visualizar Edital</a>

          <template v-if="statusEfetivo === 'ABERTA' && vaga.linkInscricao">
            <a class="btn btn-primary" :href="vaga.linkInscricao" target="_blank"
              @click="handleCliqueInscricao">Realizar Inscrição</a>
          </template>
          <template v-else-if="statusEfetivo === 'CANCELADA'">
            <button class="btn btn-disabled" disabled>
              Vaga Cancelada
            </button>
          </template>
          <template v-else-if="statusEfetivo === 'ENCERRADA'">
            <button class="btn btn-disabled" disabled>
              Inscrições Encerradas
            </button>
          </template>
        </div>
      </div>
    </main>

    <!-- Modal para Usuário Não Logado -->
    <div v-if="mostrarModalLogin" class="overlay" @click.self="mostrarModalLogin = false">
      <div class="modal-login-card">
        <div class="modal-login-header">
          <div class="modal-icon-wrapper">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
              <polyline points="10 17 15 12 10 7"></polyline>
              <line x1="15" y1="12" x2="3" y2="12"></line>
            </svg>
          </div>
          <h3>Atenção</h3>
        </div>
        <div class="modal-login-body">
          <p>
            Para entrar em contato com os coordenadores desta ação, por favor
            faça login.
          </p>
        </div>
        <div class="modal-login-footer">
          <button class="btn-modal-ok" @click="mostrarModalLogin = false">
            OK
          </button>
          <button class="btn-modal-entrar" @click="irParaLogin">
            Entrar
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal de confirmação de exclusão -->
  <Confirmacao v-if="mostrarConfirmacaoExclusao" texto="Tem certeza que deseja excluir esta vaga?"
    @confirmacao="tratarConfirmacaoExclusao" />

  <!-- Modal de aviso do resultado -->
  <Aviso v-if="mostrarAviso" :sucesso="avisoSucesso" :texto="textoAviso" @fecharModal="fecharAviso" />
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import { useRoute, useRouter } from "vue-router";
import vagasService from "@/service/vagasService";
import acaoService from "@/service/acaoService";
import userInfos from "@/utils/userInfos";
import { useAuthStore } from "@/stores/auth";
import { formatarData } from "@/utils/FormatarEntradas";
import Carregamento from "@/components/common/Carregamento.vue";
import dayjs from "dayjs";
import Confirmacao from "@/components/common/modalDeConfirmacao.vue";
import Aviso from "@/components/common/aviso.vue";

const logoAcao = ref("");

const temImagemVaga = computed(() => {
  const url = vaga.value?.imagemUrl;
  if (!url) return false;
  const str = String(url).toLowerCase();
  return (
    !str.includes("imagemdefault") &&
    !str.includes("logogex") &&
    !str.includes("default")
  );
});

const temLogoAcao = computed(() => {
  const url = logoAcao.value || vaga.value?.acaoImagemUrl;
  if (!url) return false;
  const str = String(url).toLowerCase();
  return (
    !str.includes("imagemdefault") &&
    !str.includes("logogex") &&
    !str.includes("default")
  );
});
const vaga = ref({});
const isCoordenador = ref(false);

const route = useRoute();
const router = useRouter();
const carregando = ref(false);
const authStore = useAuthStore();

const mostrarConfirmacaoExclusao = ref(false);
const mostrarAviso = ref(false);

const avisoSucesso = ref(false);
const textoAviso = ref("");
const voltarAposExclusao = ref(false);

const tipoVagaTexto = computed(() => {
  if (vaga.value?.isEstagiario) return "Estágio";
  const remunerada =
    vaga.value?.isBolsistaRemunerado ?? vaga.value?.remunerada ?? false;
  return remunerada ? "Remunerada" : "Agente";
});

const nomeAcaoExtensao = computed(() => {
  return vaga.value?.acaoTitulo || vaga.value?.acao?.titulo || vaga.value?.acao?.nome || "";
});

const acaoExtensaoId = computed(() => {
  return vaga.value?.acaoId || vaga.value?.acao?.id || route.params.id || null;
});

const tipoVagaClasse = computed(() => {
  if (vaga.value?.isEstagiario) return "estagio";
  const remunerada =
    vaga.value?.isBolsistaRemunerado ?? vaga.value?.remunerada ?? false;
  return remunerada ? "remunerada" : "voluntaria";
});

const statusEfetivo = computed(() => {
  if (!vaga.value) return "ABERTA";

  if (vaga.value.status === "CANCELADA") return "CANCELADA";
  if (vaga.value.status === "ENCERRADA") return "ENCERRADA";

  const extrairApenasData = (dataVal) => {
    if (!dataVal) return null;
    if (Array.isArray(dataVal))
      return `${dataVal[0]}-${String(dataVal[1]).padStart(2, "0")}-${String(dataVal[2]).padStart(2, "0")}`;
    if (typeof dataVal === "string") return dataVal.split("T")[0];
    return dataVal;
  };

  const hoje = dayjs().startOf("day");

  if (vaga.value.dataFimInscricao) {
    const fimStr = extrairApenasData(vaga.value.dataFimInscricao);
    if (fimStr) {
      const fim = dayjs(fimStr).startOf("day");
      if (hoje.isAfter(fim)) {
        return "ENCERRADA";
      }
    }
  }

  if (vaga.value.dataInicioInscricao) {
    const inicioStr = extrairApenasData(vaga.value.dataInicioInscricao);
    if (inicioStr) {
      const inicio = dayjs(inicioStr).startOf("day");
      if (hoje.isBefore(inicio)) {
        return "BREVE";
      }
    }
  }

  return vaga.value.status || "ABERTA";
});

const podeEditarOuExcluir = computed(() => {
  const user = userInfos.getUserInfos();
  if (!user) return false;

  const userId = user.id || user.userId || user.sub;
  const isAutor = Boolean(
    vaga.value?.autorPublicacaoId && vaga.value.autorPublicacaoId === userId
  );
  const isAdmin =
    authStore.hasRole("ADMIN") ||
    authStore.hasRole("PREX_ADMIN") ||
    authStore.hasRole("ADMINISTRADOR");
  const isCoord = isCoordenador.value;

  return isAutor || isCoord || isAdmin;
});

const breadcrumbItems = computed(() => {
  const acaoId = route.params.id || vaga.value.acaoId || vaga.value.acao?.id;
  if (acaoId) {
    return [
      { label: "Início", to: "/" },
      { label: "Ações", to: "/suas-acoes" },
      { tipo: "acao", id: acaoId, to: `/acao/${acaoId}` },
      { label: "Vagas", to: `/acao/${acaoId}/vagas-acao` },
      { label: vaga.value.titulo || "Vaga", to: `/acao/${acaoId}/vagas-acao` },
    ];
  } else {
    return [
      { label: "Início", to: "/" },
      { label: "Vagas", to: "/vagas" },
      { label: vaga.value.titulo || "Vaga", to: `/vagas` },
    ];
  }
});

async function registrarVisualizacaoSessao() {
  if (!vaga.value?.id) return;
  const vagaId = vaga.value.id;
  const storageKey = `vaga_vista_${vagaId}`;

  if (!sessionStorage.getItem(storageKey)) {
    sessionStorage.setItem(storageKey, "true");
    try {
      await vagasService.registrarVisualizacao(vagaId);
    } catch (error) {
      console.error("Erro ao registrar visualização única:", error);
    }
  }
}

async function buscarinformacoesVaga() {
  const vagaId =
    route.params.vagaId ||
    (!route.path.includes("/acao/") ? route.params.id : null);
  if (!vagaId) return;

  try {
    const resById = await vagasService.getVagaById(vagaId);
    const dados = resById?.data || resById;
    if (dados) {
      vaga.value = dados;
      await registrarVisualizacaoSessao();

      if (dados.acaoImagemUrl) {
        logoAcao.value = dados.acaoImagemUrl;
      } else {
        const targetAcaoId =
          dados.acaoId || dados.acao?.id || route.params.id;
        if (targetAcaoId) {
          try {
            const acao = await acaoService.getAcoesById(targetAcaoId);
            logoAcao.value = acao?.imagemUrl || "";
          } catch (error) {
            console.error("Erro ao buscar logo da ação:", error);
          }
        }
      }
    }
  } catch (error) {
    console.error("Erro ao buscar vaga por ID:", error);
  }
}

async function verificarCoordenador() {
  try {
    const user = userInfos.getUserInfos();
    if (!user) {
      isCoordenador.value = false;
      return;
    }

    const targetAcaoId =
      route.params.id || vaga.value?.acaoId || vaga.value?.acao?.id;
    if (!targetAcaoId) {
      isCoordenador.value = false;
      return;
    }

    isCoordenador.value = await acaoService.verificarCoordenador(targetAcaoId);
  } catch (error) {
    console.error("Erro ao verificar coordenação:", error);
    isCoordenador.value = false;
  }
}

function irParaEdicao() {
  const targetAcaoId =
    route.params.id || vaga.value?.acaoId || vaga.value?.acao?.id;
  const targetVagaId = vaga.value?.id || route.params.vagaId;

  if (targetAcaoId && targetVagaId) {
    router.push({
      name: "editar-vaga",
      params: { id: targetAcaoId, vagaId: targetVagaId },
    });
  } else if (targetVagaId) {
    router.push(`/editar-vaga/${targetVagaId}`);
  }
}
// Abre o modal de confirmação
function confirmarExclusao() {
  mostrarConfirmacaoExclusao.value = true;
}

// Trata a resposta do componente de confirmação
async function tratarConfirmacaoExclusao(confirmado) {
  mostrarConfirmacaoExclusao.value = false;

  // Se clicar em Não ou fechar o modal, não exclui
  if (!confirmado) return;

  try {
    await vagasService.deleteVaga(vaga.value.id);

    avisoSucesso.value = true;
    textoAviso.value = "Vaga excluída com sucesso!";
    voltarAposExclusao.value = true;
    mostrarAviso.value = true;
  } catch (error) {
    console.error("Erro ao excluir vaga:", error);

    avisoSucesso.value = false;
    textoAviso.value = "Ocorreu um erro ao excluir a vaga.";
    voltarAposExclusao.value = false;
    mostrarAviso.value = true;
  }
}

// Fecha o aviso e navega caso a exclusão tenha sido concluída
function fecharAviso() {
  mostrarAviso.value = false;

  if (voltarAposExclusao.value) {
    voltarAposExclusao.value = false;

    const acaoId =
      route.params.id || vaga.value.acaoId || vaga.value.acao?.id;

    if (acaoId) {
      router.push(`/acao/${acaoId}/vagas`);
    } else {
      router.push("/vagas");
    }
  }
}

const mostrarModalLogin = ref(false);

function irParaLogin() {
  router.push("/login");
}

onMounted(async () => {
  carregando.value = true;
  await buscarinformacoesVaga();
  await verificarCoordenador();
  carregando.value = false;
});
</script>

<style scoped>
.main-content {
  flex: 1;
  width: 100%;
  margin: 0;
  padding: 0;
}

.content-card {
  background: var(--branco);
  border-radius: 0;
  box-shadow: none;
  min-height: 100vh;
}

/* ── Título ── */
.page-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--preto);
  margin-bottom: 16px;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.info-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--cinza-escuro);
}

.info-date {
  font-size: 13px;
  border: 1px solid var(--cinza-claro);
  border-radius: 20px;
  padding: 2px 10px;
  color: var(--cinza-escuro);
  background: var(--branco);
}

.info-date.highlight {
  border-color: var(--roxo-primario);
  color: var(--branco);
  background: var(--roxo-medio);
  font-weight: 600;
}

.info-value {
  font-size: 13px;
  color: var(--cinza-escuro);
}

.info-link {
  font-size: 13px;
  font-weight: 500;
  color: var(--roxo-medio);
  text-decoration: none;
  transition: color 0.2s ease;
}

.info-link:hover {
  color: var(--roxo-primario);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.info-link:focus-visible {
  outline: 2px solid var(--roxo-claro);
  outline-offset: 2px;
  border-radius: 2px;
}

.tipo-vaga-badge {
  font-size: 12px;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
}

.tipo-vaga-badge.remunerada {
  background-color: var(--roxo-superficie);
  color: var(--roxo-medio);
  border: 1px solid var(--roxo-medio);
}

.tipo-vaga-badge.voluntaria {
  background-color: var(--cinza-claro);
  color: var(--cinza-escuro);
  border: 1px solid var(--cinza-escuro);
}

.tipo-vaga-badge.estagio {
  background-color: var(--laranja-claro);
  color: var(--laranja-escuro);
  border: 1px solid var(--laranja-claro);
}

.status-badge {
  font-size: 12px;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
}

.status-badge.aberta {
  background-color: var(--verde-claro);
  color: var(--verde-escuro);
  border: 1px solid var(--verde-claro);
}

.status-badge.breve {
  background-color: var(--cinza-claro);
  color: var(--cinza-escuro);
  border: 1px solid var(--cinza-medio);
}

.status-badge.encerrada {
  background-color: var(--laranja-claro);
  color: var(--laranja-escuro);
  border: 1px solid var(--laranja-claro);
}

.status-badge.cancelada {
  background-color: var(--vermelho-claro);
  color: var(--vermelho-escuro);
  border: 1px solid var(--vermelho-claro);
}

.metrics-panel {
  display: flex;
  gap: 16px;
  margin: 16px 0;
  flex-wrap: wrap;
}

.metric-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--branco);
  border: 1px solid var(--cinza-claro);
  border-radius: 10px;
  padding: 12px 18px;
  min-width: 160px;
}

.metric-info {
  display: flex;
  gap: 10px;
  align-items: center;
}

.metric-value {
  font-size: 18px;
  font-weight: 700;
  color: var(--cinza-escuro);
}

.metric-label {
  font-size: 12px;
  color: var(--cinza-medio);
  font-weight: 500;
}

.nucleo-label {
  font-size: 13px;
  color: var(--cinza-escuro);
  margin-bottom: 14px;
}

.divider {
  border-top: 3px solid var(--preto);
  margin: 0 0 16px 0;
}

/* ── Imagem da Vaga Centralizada no Topo ── */
.vaga-imagem-topo {
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  width: 100%;
  margin-bottom: 24px;
}

.vaga-image {
  width: 100%;
  max-width: 600px;
  height: auto;
  aspect-ratio: 16 / 9;     /* Formato retangular que corta a sobra de baixo */
  object-fit: cover;        /* Preenche o espaço sem distorcer */
  object-position: center;     /* Mantém o foco no topo e elimina o espaço vazio inferior */
  display: block;
}

.vaga-text {
  width: 100%;
  margin-bottom: 24px;
}

/* ── Tags ── */
.tags-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
}

.tag {
  font-size: 12px;
  border: 2px solid var(--cinza-medio);
  border-radius: 5px;
  padding: 3px 12px;
  color: var(--cinza-escuro);
  background: var(--branco);
}

.nerds-section {
  display: flex;
  gap: 20px;
  margin-top: 24px;
  align-items: flex-start;
}

.nerds-image-wrapper {
  flex-shrink: 0;
}

.nerds-image {
  width: 220px;
  height: 140px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
}

.nerds-text {
  flex: 1;
}

.nerds-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--preto);
  margin-bottom: 8px;
}

.nerds-text p {
  font-size: 13px;
  line-height: 1.7;
  color: var(--cinza-escuro);
  margin: 0;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
}

.btn {
  padding: 10px 14px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  transition:
    opacity 0.2s,
    background 0.2s;
}

.btn-outline {
  background: var(--branco);
  border: 1px solid var(--roxo-primario);
  color: var(--roxo-primario);
}

.btn-outline:hover {
  background: var(--roxo-superficie);
  border: 1px solid var(--roxo-primario);
  color: var(--roxo-primario);
}

.btn-primary {
  background: var(--roxo-primario);
  color: var(--branco);
}

.btn-primary:hover {
  background: var(--roxo-medio);
}

.btn-disabled {
  background: var(--cinza-claro);
  color: var(--cinza-medio);
  cursor: not-allowed;
  border: none;
}

.btn-danger {
  background: var(--vermelho-escuro);
  color: var(--branco);
  text-decoration: none;
}

.btn-danger:hover {
  background: var(--vermelho);
}



.modal-login-card {
  background: var(--branco);
  border-radius: 16px;
  width: 100%;
  max-width: 420px;
  padding: 24px;
  box-shadow:
    0 20px 25px -5px hsla(0, 0%, 0%, 0.1),
    0 10px 10px -5px hsla(0, 0%, 0%, 0.04);
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: modalFadeIn 0.25s ease-out;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.modal-login-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-icon-wrapper {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--roxo-superficie);
  color: var(--roxo-primario);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-login-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: var(--cinza-escuro);
  margin: 0;
}

.modal-login-body p {
  font-size: 14px;
  color: var(--cinza-escuro);
  line-height: 1.5;
  margin: 0;
}

.modal-login-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
}

.btn-modal-ok {
  padding: 8px 20px;
  border-radius: 8px;
  border: 1.5px solid var(--cinza-claro);
  background: var(--branco);
  color: var(--cinza-escuro);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-modal-ok:hover {
  background: var(--cinza-claro);
  border-color: var(--cinza-medio);
}

.btn-modal-entrar {
  padding: 8px 24px;
  border-radius: 8px;
  border: none;
  background: var(--roxo-primario);
  color: var(--branco);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px hsla(258, 53%, 28%, 0.2);
}

.btn-modal-entrar:hover {
  background: var(--roxo-primario);
  box-shadow: 0 4px 8px hsla(258, 53%, 28%, 0.3);
}

@media (max-width: 768px) {
  .nerds-section {
    flex-direction: column;
    gap: 16px;
  }

  .nerds-image-wrapper {
    width: 100%;
  }

  .nerds-image {
    width: 100%;
    height: auto;
    max-height: 220px;
  }

  .page-title {
    font-size: 20px;
  }

  .info-row {
    gap: 12px;
  }

  .metric-card {
    flex: 1 1 140px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .action-buttons .btn {
    width: 100%;
  }
}
</style>
